import React from "react";
import { Outlet, Routes, Route, useLocation, Navigate, useParams, useNavigate } from "react-router-dom";
import Layout from "./Layout/layout";
import { AuthProvider, RequireAuth, RequireAdmin, removeAllLocalState } from "./Services/auth";
import "bootstrap/scss/bootstrap.scss";
// import "bootstrap/scss/_variables.scss";
import "./SCSS/theme.scss";
import "./SCSS/variables.scss";
import "./SCSS/components.scss";
import "./SCSS/structure.scss";
import "./SCSS/pages.scss";
import "./SCSS/plugins.scss";
// import "./node_modules/bootstrap/scss/mixins.scss";
// import "./node_modules/bootstrap/scss/bootstrap";
// import "./node_modules/bootstrap/scss/functions";
import "leaflet/dist/leaflet.css";
import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";
import { StrategyService } from "./Services/strategies/strategyService";
import ScreenSpinner from "./Components/ScreenSpinner";
import { useTabStore } from "./Stores/tabStore";
import { useTenderStrategyStore } from "./Stores/tenderStrategyStore";
import devDebug from "./Helpers/debug";
import { ErrorBoundary } from "react-error-boundary";
import { MainAppErrorComponent } from "./Components/errorComponent";
import i18n from "./i18n";
import MyTendersErrorBoundary from "./Pages/Protected - My Tenders/MyTendersErrorBoundary";
import VademecumErrorBoundary from "./Pages/Admin - Vademecum/VademecumErrorBoundary";
import { useTranslation } from "react-i18next";
import { languages } from "./Assets/Defaults/defaults";

const Logout = ({ removeAuth }) => {
  removeAllLocalState(removeAuth); //true means auth data also gets deleted

  if (removeAuth) {
    return <Navigate to={`/${i18n.language.slice(0, 2)}/`} />;
  } else {
    useTenderStrategyStore.getState().setTriggerStrategyReload();
    devDebug("This is current location", window.location);
    <Navigate to={`/${i18n.language.slice(0, 2)}/`} />;
  }
};

const AddTenderFileUploadPage = React.lazy(() => import("./Pages/Admin - Add Tender File Upload/addTenderFileUpload"));

const LoginPage = React.lazy(() => import("./Pages/Public - Login/login"));
const TenderStrategy = React.lazy(() => import("./Pages/Protected - Tender Strategy/tenderStrategy"));
const RegisterErrorBoundary = React.lazy(() => import("./Pages/Public - Register/RegisterErrorBoundary"));
const Dashboard = React.lazy(() => import("./Pages/Public - Dashboard/dashboard"));
const Services = React.lazy(() => import("./Pages/Public - Services/servicesPage"));
const TenderAwardsMain = React.lazy(() => import("./Pages/Protected - Tender Awards/TenderAwardsMain"));
const ForwardEmailLink = React.lazy(() => import("./Pages/Public - Forwarders/forwardEmailLink"));
const UserPreferences = React.lazy(() => import("./Pages/Protected - User Preferences/userPreferences"));
const Pricing = React.lazy(() => import("./Pages/Public - Pricing/pricing"));
const Contact = React.lazy(() => import("./Pages/Public - Contact/contact"));
const AlboFornitori = React.lazy(() => import("./Pages/Protected - Albo Fornitori/alboFornitoriInit"));
const TenderSearch = React.lazy(() => import("./Pages/Protected - Tender Search/tenderSearchInit"));
const TenderAwardsSearch = React.lazy(() => import("./Pages/Protected - Tender Awards Search/tenderAwardsSearchInit"));
const CompaniesSearchErrorBoundary = React.lazy(() =>
  import("./Pages/Protected - Companies Search/CompaniesSearchErrorBoundary")
);
const ForgotPasswordPage = React.lazy(() => import("./Pages/Public - Forgot Password/forgotPassword"));
const CompletePwdReset = React.lazy(() => import("./Pages/Public - Complete Password Reset/completePwdReset"));
const ListUsersErrorBoundary = React.lazy(() => import("./Pages/Admin - List Users/ListUsersErrorBoundary"));
const EditUserErrorBoundary = React.lazy(() => import("./Pages/Admin - Edit User/EditUserErrorBoundary"));
const ViewTenderPage = React.lazy(() => import("./Pages/View Tender/viewTenderPage"));
const ViewSupplierListNotice = React.lazy(() => import("./Pages/View Supplier List Notice/ViewSupplierListNoticeInit"));
const CPVStats = React.lazy(() => import("./Pages/Public - CPV Stats/CPVStats"));
const UserVademecumErrorBoundary = React.lazy(() => import("./Pages/Protected - Vademecum/VademecumErrorBoundary"));

const initChat = () => {
  window.ailabs_user_info = {
    client: "ufficioappalti",
    header: "Tenders.club Chat",
    welcome_message: "Welcome to the chat 👋",
  };

  if (window.AILabsChatStart) {
    window.AILabsChatStart();
  }
};

const ChatWidget = () => {
  React.useEffect(() => {
    // Load script
    const script = document.createElement("script");
    script.setAttribute("type", "text/javascript");
    script.setAttribute("src", "https://s2.webapi.ai/chat-widget/uniq-chat.js");
    script.async = true;

    // Initialize chat when script loads
    script.onload = initChat;

    document.body.appendChild(script);

    // Cleanup
    return () => {
      document.body.removeChild(script);
      // Clean up any chat instance if needed
      if (window.AILabsChatDestroy) {
        window.AILabsChatDestroy();
      }
    };
  }, []);

  return null;
};

const FeedbackWidget = () => {
  React.useEffect(() => {
    // Configure feedback widget
    window.fbl_2020_Widget_Config = {
      position: "left",
      color: "light",
      link: "https://feedback.link/tendersclub",
      brandHex: "#2D2F41",
      frequency: "t",
    };

    // Load script
    const feedbackScript = document.createElement("script");
    feedbackScript.setAttribute(
      "src",
      "https://feedback.link/web_widget/feedbackbutton?id=FYC7vG8aTDFv7zafCG6bEqJ0sjHyzaGN2WWG9s1680867759"
    );
    feedbackScript.async = true;

    document.body.appendChild(feedbackScript);

    // Cleanup
    return () => {
      document.body.removeChild(feedbackScript);
    };
  }, []);

  return null;
};

const Scripts = () => {
  return (
    <>
      <ChatWidget />
      <FeedbackWidget />
    </>
  );
};

function LanguagePath() {
  const { i18n } = useTranslation();
  const { lang } = useParams();
  const navigate = useNavigate();
  const curPath = window.location.pathname;
  React.useEffect(() => {
    if (lang && i18n.resolvedLanguage !== lang) {
      if (languages.includes(lang)) {
        i18n.changeLanguage(lang);
      } else {
        navigate("/" + i18n.resolvedLanguage + curPath, { replace: true });
      }
    }
  }, [lang]);
  return <Outlet />;
}

function NoMatch() {
  devDebug(`Route ${window.location.pathname} did not match, redirecting...`);
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const { lang } = useParams();
  React.useEffect(() => {
    devDebug("LanguagePath -> language is: ", i18n.language);
    devDebug("LanguagePath -> resolvedLanguage is: ", i18n.resolvedLanguage);

    const curPath = window.location.pathname;
    devDebug("LanguagePath -> current path is: ", curPath);
    devDebug("LanguagePath -> language is: ", lang);

    if (
      !curPath.includes("/en/") &&
      !curPath.includes("/de/") &&
      !curPath.includes("/fr/") &&
      !curPath.includes("/es/") &&
      !curPath.includes("/it/")
    ) {
      if (lang && i18n.resolvedLanguage !== lang) {
        if (languages.includes(lang)) {
          i18n.changeLanguage(lang);
        } else {
          navigate("/" + i18n.resolvedLanguage + curPath, { replace: true });
        }
      } else {
        navigate("/" + i18n.resolvedLanguage + curPath, { replace: true });
      }
    } else {
      devDebug("No Match -> navigating to dashboard");
      navigate(`/${i18n.language.slice(0, 2)}/`);
    }

    return () => {};
  }, [lang]);
  return <div></div>;
}

export default function App() {
  const location = useLocation();
  const [setTabID] = useTabStore((state) => [state.setTabID]);
  const [setUserLoaded] = useTenderStrategyStore((state) => [state.setUserLoaded]);

  React.useEffect(() => {
    // execute on location change
    devDebug(`App -> location is: ${location.pathname}`);

    setUserLoaded(false);
    setTabID("edit_user", null);
    //edit user is always reset, as admins will load different
    //users frequently, so needs resetting just about always
  }, [location]);

  return (
    <ErrorBoundary
      FallbackComponent={MainAppErrorComponent}
      onReset={(details) => {
        devDebug("App -> error boundary reset", details);
        removeAllLocalState(false); //authentication data is not removed in this instance
        useTenderStrategyStore.getState().setTriggerStrategyReload();
      }}
    >
      <Routes>
        <Route path="/logout" element={<Logout removeAuth={true} />} />
        <Route path="/dstate" element={<Logout removeAuth={false} />} />
      </Routes>

      <AuthProvider>
        <StrategyService>
          <Routes>
            <Route element={<Layout />}>
              <Route path=":lang/" element={<LanguagePath />}>
                {/* ------------------------------- ROUTES WITHOUT AUTH ----------------------------- */}
                <Route
                  path="viewtenderpublic/:id"
                  element={
                    // screen spinners translate within the component
                    <React.Suspense fallback={<ScreenSpinner copy="Loading Public Tender..." />}>
                      <ViewTenderPage isAdminRoute={false} isPublicRoute={true} section="view_tender_public" />
                    </React.Suspense>
                  }
                />
                <Route
                  path=""
                  element={
                    // screen spinners translate within the component
                    <React.Suspense fallback={<ScreenSpinner copy="Loading Dashboard..." />}>
                      <Dashboard />
                    </React.Suspense>
                  }
                />
                <Route
                  path="login"
                  element={
                    // screen spinners translate within the component
                    <React.Suspense fallback={<ScreenSpinner copy="Loading Login..." />}>
                      <LoginPage />
                    </React.Suspense>
                  }
                />
                <Route
                  path="register"
                  element={
                    // screen spinners translate within the component
                    <React.Suspense fallback={<ScreenSpinner copy="Loading Registration..." />}>
                      <RegisterErrorBoundary />
                    </React.Suspense>
                  }
                />
                <Route
                  path="services"
                  element={
                    // screen spinners translate within the component
                    <React.Suspense fallback={<ScreenSpinner copy="Loading Services..." />}>
                      <Services />
                    </React.Suspense>
                  }
                />
                <Route
                  path="contact"
                  element={
                    // screen spinners translate within the component
                    <React.Suspense fallback={<ScreenSpinner copy="Loading Contact..." />}>
                      <Contact />
                    </React.Suspense>
                  }
                />
                <Route
                  path="cpv_stats"
                  element={
                    // screen spinners translate within the component
                    <React.Suspense fallback={<ScreenSpinner copy="Loading CPV Statistics..." />}>
                      <CPVStats />
                    </React.Suspense>
                  }
                />
                <Route
                  path="forgot-password"
                  element={
                    // screen spinners translate within the component
                    <React.Suspense fallback={<ScreenSpinner copy="Loading Password Reset..." />}>
                      <ForgotPasswordPage />
                    </React.Suspense>
                  }
                />

                <Route
                  path="pricing"
                  element={
                    // screen spinners translate within the component
                    <React.Suspense fallback={<ScreenSpinner copy="Loading Pricing..." />}>
                      <Pricing />
                    </React.Suspense>
                  }
                />
                <Route
                  path="guest/registration/account-confirm-email/:token"
                  element={
                    // screen spinners translate within the component
                    <React.Suspense fallback={<ScreenSpinner copy="Confirming Email..." />}>
                      <ForwardEmailLink />
                    </React.Suspense>
                  }
                />
                <Route
                  path="password-reset-confirm/:uid/:token"
                  element={
                    // screen spinners translate within the component
                    <React.Suspense fallback={<ScreenSpinner copy="Loading Password Reset..." />}>
                      <CompletePwdReset />
                    </React.Suspense>
                  }
                />
                {/* ------------------------------- ROUTES WITH AUTH ----------------------------- */}

                <Route
                  path="tender_awards"
                  element={
                    <RequireAuth>
                      {/* screen spinners translate within the component */}
                      <React.Suspense fallback={<ScreenSpinner copy="Loading Tender Awards..." />}>
                        <TenderAwardsMain section="tender_awards" />
                      </React.Suspense>
                    </RequireAuth>
                  }
                />
                <Route
                  path="awards_search"
                  element={
                    <RequireAuth>
                      {/* screen spinners translate within the component */}
                      <React.Suspense fallback={<ScreenSpinner copy="Loading Awards Search..." />}>
                        <TenderAwardsSearch section="awards_search" />
                      </React.Suspense>
                    </RequireAuth>
                  }
                />
                <Route
                  path="companies_search"
                  element={
                    <RequireAuth>
                      {/* screen spinners translate within the component */}
                      <React.Suspense fallback={<ScreenSpinner copy="Loading Companies Search..." />}>
                        <CompaniesSearchErrorBoundary section="companies_search" />
                      </React.Suspense>
                    </RequireAuth>
                  }
                />
                <Route
                  path="search"
                  element={
                    <RequireAuth>
                      {/* screen spinners translate within the component */}
                      <React.Suspense fallback={<ScreenSpinner copy="Loading Tender Search..." />}>
                        <TenderSearch admin={false} />
                      </React.Suspense>
                    </RequireAuth>
                  }
                />
                <Route
                  path="tender_strategy"
                  element={
                    <RequireAuth>
                      {/* screen spinners translate within the component */}
                      <React.Suspense fallback={<ScreenSpinner copy="Loading Tender Strategies..." />}>
                        <TenderStrategy section="tender_strategy" />
                      </React.Suspense>
                    </RequireAuth>
                  }
                />
                <Route
                  path="user_preferences"
                  element={
                    <RequireAuth>
                      {/* screen spinners translate within the component */}
                      <React.Suspense fallback={<ScreenSpinner copy="Loading Settings..." />}>
                        <UserPreferences />
                      </React.Suspense>
                    </RequireAuth>
                  }
                />
                <Route
                  path="view_tender/:id"
                  element={
                    <RequireAuth>
                      {/* screen spinners translate within the component */}
                      <React.Suspense fallback={<ScreenSpinner copy="Loading Tender..." />}>
                        <ViewTenderPage isAdminRoute={false} isPublicRoute={false} section="view_tender_protected" />
                      </React.Suspense>
                    </RequireAuth>
                  }
                />
                <Route
                  path="my_tenders"
                  element={
                    <RequireAuth>
                      {/* screen spinners translate within the component */}
                      <React.Suspense fallback={<ScreenSpinner copy="Loading My Tenders..." />}>
                        <MyTendersErrorBoundary />
                      </React.Suspense>
                    </RequireAuth>
                  }
                />
                <Route
                  path="vademecums"
                  element={
                    <RequireAuth>
                      {/* screen spinners translate within the component */}
                      <React.Suspense fallback={<ScreenSpinner copy="Loading Summaries..." />}>
                        <UserVademecumErrorBoundary />
                      </React.Suspense>
                    </RequireAuth>
                  }
                />
                <Route
                  path="view_supplier_list_notice/:id"
                  element={
                    //todo: change this to become requireAuth, instead of admin, when ready for normal users
                    <RequireAdmin>
                      {/* screen spinners translate within the component */}
                      <React.Suspense fallback={<ScreenSpinner copy="Loading Supplier List Notice..." />}>
                        <ViewSupplierListNotice isAdminRoute={false} section="view_supplier_list_notice" />
                      </React.Suspense>
                    </RequireAdmin>
                  }
                />
                <Route
                  path="supplier_list_notices"
                  element={
                    //todo: change this to become requireAuth, instead of admin, when ready for normal users
                    <RequireAdmin>
                      {/* screen spinners translate within the component */}
                      <React.Suspense fallback={<ScreenSpinner copy="Loading Supplier List Notices..." />}>
                        <AlboFornitori section="supplier_list_notices" admin={false} />
                      </React.Suspense>
                    </RequireAdmin>
                  }
                />
                {/* ------------------------------- ADMIN ROUTES ----------------------------- */}
                <Route
                  path="admin/view_supplier_list_notice/:id"
                  element={
                    <RequireAdmin>
                      {/* screen spinners translate within the component */}
                      <React.Suspense fallback={<ScreenSpinner copy="Loading Supplier List Notices..." />}>
                        <ViewSupplierListNotice isAdminRoute={true} section="edit_supplier_list_notice" />
                      </React.Suspense>
                    </RequireAdmin>
                  }
                />
                <Route
                  path="admin/supplier_list_notices"
                  element={
                    <RequireAdmin>
                      {/* screen spinners translate within the component */}
                      <React.Suspense fallback={<ScreenSpinner copy="Loading Supplier List Notices..." />}>
                        <AlboFornitori section="supplier_list_notices_admin" admin={true} />
                      </React.Suspense>
                    </RequireAdmin>
                  }
                />
                <Route
                  path="admin/edit_user/:id"
                  element={
                    <RequireAdmin>
                      {/* screen spinners translate within the component */}
                      <React.Suspense fallback={<ScreenSpinner copy="Loading Edit User..." />}>
                        <EditUserErrorBoundary mode="edit" section="edit_user" />
                      </React.Suspense>
                    </RequireAdmin>
                  }
                />
                <Route
                  path="admin/edit_tenders"
                  element={
                    <RequireAdmin>
                      {/* screen spinners translate within the component */}
                      <React.Suspense fallback={<ScreenSpinner copy="Loading Edit Tender..." />}>
                        <TenderSearch admin={true} />
                      </React.Suspense>
                    </RequireAdmin>
                  }
                />
                <Route
                  path="admin/list_users"
                  element={
                    <RequireAdmin>
                      {/* screen spinners translate within the component */}
                      <React.Suspense fallback={<ScreenSpinner copy="Loading User List..." />}>
                        <ListUsersErrorBoundary />
                      </React.Suspense>
                    </RequireAdmin>
                  }
                />
                <Route
                  path="admin/add_user"
                  element={
                    <RequireAdmin>
                      {/* screen spinners translate within the component */}
                      <React.Suspense fallback={<ScreenSpinner copy="Loading Add User..." />}>
                        <EditUserErrorBoundary mode="add" section="edit_user" />
                      </React.Suspense>
                    </RequireAdmin>
                  }
                />
                <Route
                  path="admin/vademecum"
                  element={
                    <RequireAdmin>
                      {/* screen spinners translate within the component */}
                      <React.Suspense fallback={<ScreenSpinner copy="Loading Vademecum..." />}>
                        <VademecumErrorBoundary />
                      </React.Suspense>
                    </RequireAdmin>
                  }
                />
                <Route
                  path="admin/view_tender/:id"
                  element={
                    <RequireAdmin>
                      {/* screen spinners translate within the component */}
                      <React.Suspense fallback={<ScreenSpinner copy="Loading Tender..." />}>
                        <ViewTenderPage isAdminRoute={true} isPublicRoute={false} section="edit_tender" />
                      </React.Suspense>
                    </RequireAdmin>
                  }
                />
                <Route
                  path="admin/add_tender"
                  element={
                    <RequireAdmin>
                      {/* screen spinners translate within the component */}
                      <React.Suspense fallback={<ScreenSpinner copy="Loading Tender..." />}>
                        <ViewTenderPage isAdminRoute={true} isPublicRoute={false} section="add_tender" />
                      </React.Suspense>
                    </RequireAdmin>
                  }
                />
                <Route
                  path="admin/add_tender_file_upload"
                  element={
                    <RequireAdmin>
                      {/* screen spinners translate within the component */}
                      <React.Suspense fallback={<ScreenSpinner copy="Loading Add Tender File Upload Section..." />}>
                        <AddTenderFileUploadPage section="add_tender_file_upload" />
                      </React.Suspense>
                    </RequireAdmin>
                  }
                />
              </Route>
            </Route>
            <Route path="*" element={<NoMatch />} />
          </Routes>
        </StrategyService>
      </AuthProvider>
      <Scripts />
    </ErrorBoundary>
  );
}
